import React, { useState } from 'react';
import './App.css';
import { translations } from './i18n/translations';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import SAPSpecialty from './components/SAPSpecialty';
import WorkTypes from './components/WorkTypes';
import Projects from './components/Projects';
import ForCompanies from './components/ForCompanies';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [currentLang, setCurrentLang] = useState('pt');
  const t = translations[currentLang];

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
  };

  return (
    <div className="App">
      <Navigation 
        t={t} 
        currentLang={currentLang} 
        onLanguageChange={handleLanguageChange} 
      />
      <Hero t={t} />
      <About t={t} />
      <Skills t={t} />
      <SAPSpecialty t={t} />
      <WorkTypes t={t} />
      <Projects t={t} />
      <ForCompanies t={t} />
      <Contact t={t} />
      <Footer t={t} />
    </div>
  );
}

export default App;